import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import L from 'leaflet'
import 'leaflet.heat'

/**
 * HeatmapLayer component for react-leaflet
 * Wraps leaflet.heat plugin
 */
const HeatmapLayer = ({ points, options = {} }) => {
  const map = useMap()

  useEffect(() => {
    if (!points || points.length === 0) return

    // Default heatmap options
    const defaultOptions = {
      radius: 25,
      blur: 15,
      maxZoom: 17,
      max: 1.0,
      minOpacity: 0.4,
      gradient: {
        0.0: 'blue',
        0.2: 'lime',
        0.4: 'yellow',
        0.6: 'orange',
        0.8: 'red',
        1.0: 'darkred'
      },
      ...options
    }

    // Create heatmap layer
    const heatLayer = L.heatLayer(points, defaultOptions)
    
    // Add to map
    heatLayer.addTo(map)

    // Cleanup on unmount or when points change
    return () => {
      map.removeLayer(heatLayer)
    }
  }, [map, points, options])

  return null
}

export default HeatmapLayer

